import type { Bonus } from '../types/product';

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Schede visive di consultazione rapida',
    description: 'Domande, confronti e promemoria per trovare rapidamente il passaggio che ti serve.',
    pages: '10 pagine',
    cover: 'https://cdn.magicpatterns.com/uploads/sHsju4yXXsUhDz4Ppfyff4/Fichas_visuales_botanicas_de_Bach-3.png',
  },
  {
    number: '02',
    title: 'Fiori di Bach per uso topico — Guida pratica',
    description: 'Usi tradizionali esterni, prodotti, etichette, ingredienti, igiene e precauzioni.',
    pages: '15 pagine',
    cover: 'https://cdn.magicpatterns.com/uploads/gpAguWC72bh2GtqZ5vkhj1/Flores_de_Bach_para_uso_topico-4.png',
  },
  {
    number: '03',
    title: 'Schede cliente e diario di follow-up',
    description:
      'Modelli per annotare il motivo dell’incontro, le parole della persona, la proposta e la revisione del percorso.',
    pages: '15 pagine',
    cover: 'https://cdn.magicpatterns.com/uploads/63QcvZkCr6LEpsLWrgAWLJ/Portada_botanica_para_fichas_de_seguimiento-5.png',
  },
  {
    number: '04',
    title: 'Lo Scudo dell’Operatore — Confini e cura di sé',
    description: 'Disponibilità, accordi, pause e organizzazione personale per una pratica più sostenibile.',
    pages: '20 pagine',
    cover: 'https://cdn.magicpatterns.com/uploads/3GWqa73b2VRgaNexUUxQzH/Portada_botanica_del_escudo_del_operador-6.png',
  },
  {
    number: '05',
    title: 'La tua attività di consulenza floreale',
    description:
      'Una guida per presentare il servizio, comunicare i prezzi, organizzare l’agenda e accompagnare il cliente nel follow-up.',
    pages: '20 pagine',
    cover: 'https://cdn.magicpatterns.com/uploads/mJ8jBWxXrhx9cWujLkrmn7/Guia_elegante_de_consultoria_floral-7.png',
  },
];
